import React, { Component } from "react";
import axios from "axios";
import qs from "qs";
import debounce from "lodash/debounce";

// Components
import ProductItem from "./ProductItem";

// State
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../../shared/vars";

class ProductSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			q: "",
			error: "",
			canSearch: false,
			products: [],
			productSelections: [],
			selectedIndex: 0,
			visible: false
		};

		// Handle click outside of react element
		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.setState({
				...this.state,
				visible: false
			});
		}
	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			event.preventDefault();

			if (this.state.visible) {
				this.handleProductClick(this.state.products[this.state.selectedIndex], "product");
			} else {
				this.performSearch();
			}
		}
	}

	handleKeyPressDebouncer = debounce(function(value) {
		this.performSearch();
	});

	handleKeyDown(event) {
		if (event.key === "ArrowDown") {
			this.arrowKeyDown();
		} else if (event.key === "ArrowUp") {
			this.arrowKeyUp();
		} else if (event.key === "Escape") {
			this.setState({
				visible: false
			});
		}
	}

	handleInputChange(event) {
		const { value } = event.target;
		this.setState(
			{
				...this.state,
				canSearch: true,
				q: value
			},
			this.handleKeyPressDebouncer(value)
		);
	}

	arrowKeyDown() {
		let { selectedIndex, visible } = this.state;

		// Only move item if list if visible
		if (visible) {
			selectedIndex += this.state.products.length - 1 > selectedIndex ? 1 : 0;
		}

		this.setState({
			visible: true,
			selectedIndex
		});
	}

	arrowKeyUp() {
		let { selectedIndex, visible } = this.state;

		// Only move item if list if visible
		if (visible) {
			selectedIndex -= selectedIndex > 0 ? 1 : 0;
		}

		this.setState({
			visible: true,
			selectedIndex
		});
	}

	performSearch() {
		const { q, canSearch } = this.state;
		const { currentlySelected } = this.props;

		// If nothing has changed in the search term, do nothing
		if (!canSearch) return;

		// If the query string is empty, set empty collection
		if (q === "") {
			this.setState({
				selectedIndex: 0,
				canSearch: false,
				products: []
			});
			return;
		}

		const selectionIds = currentlySelected.map(item => {
			return item.id;
		});

		this.setState({
			selectedIndex: 0,
			canSearch: false
		});

		// Put querystring data together
		const data = qs.stringify(
			{
				q,
				currentlySelected: selectionIds
			},
			{ arrayFormat: ["brackets"] }
		);

		// Make ajax call
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
		return axios
			.get(REACT_APP_API_URL + "products-query?" + data, { headers: AUTH_HEADER })
			.then(response => {
				if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
					this.setState({ isLoading: false, error: response.data.message, products: [], visible: false });
				} else {
					this.setState({ isLoading: false, products: !!response.data.products ? response.data.products : [], visible: true });
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message, products: [], visible: false });
				} else {
					this.setState({ isLoading: false, error: err.message, products: [], visible: false });
				}
			});
	}

	handleProductClick = (item, type, noVariants) => {
		let { currentlySelected } = this.props;
		let curItem = {};

		//Featured Products Exception
		if(type === "featured_product"){
			curItem = item;
		}
		else{
			// no_variants means its a variant itself or its a product with 0 variants
			if(type === "variant"){
				curItem = {
					id: item.id,
					product_id: item.product_id,
					title: item.sku,
					type: 'variant',
					no_variants: noVariants
				}
			} else {
				curItem = {
					id: item.id,
					title: item.title,
					type: 'product',
					no_variants: noVariants
				}
			}
			currentlySelected.push(curItem);
		}

		this.setState({
			...this.state,
			visible: false
		});
		if(type === "featured_product"){
			this.props.updateHandler(curItem);
		} else {
			this.props.updateHandler(currentlySelected);
		}
	}

	render() {
		const { q, products, visible, selectedIndex } = this.state;
		const { currentlySelected, ignoreVariants } = this.props;

		return (
			<div className="ajax-search-wrapper">
				<div className={`input-placeholder-wrapper placeholder--search-field ${this.props.disabled ? 'disabled' : ''}`}>
					<span className="placeholder icon-search" />
					<input type="text" value={q} placeholder="Search products" onKeyPress={e => this.handleKeyPress(e)} onKeyDown={e => this.handleKeyDown(e)} onChange={e => this.handleInputChange(e)} disabled={this.props.disabled}/>
				</div>
				<div className="ajax-search-content categories">
					{products.length && visible ? (
						<div className="search-dialog" ref={this.setWrapperRef}>
							<div className="tooltip-arrow" />
							<div className="content">
								{products.slice(0, 10).map((cat, i) => {
									return <ProductItem key={i} currentlySelected={currentlySelected} product={cat} ignoreVariants={ignoreVariants} isSelected={i === selectedIndex} handleProductClick={product => this.handleProductClick(product)} variantClicked={this.handleProductClick} />;
								})}
							</div>
						</div>
					) : null}
				</div>
			</div>
		);
	}
}

export default ProductSearch;



// WEBPACK FOOTER //
// ./src/components/admin/products/product-search/ProductSearch.js